module.exports = __webpack_public_path__ + "static/media/faiar.17051a94.jpg";